const data = {
  category: {'个人随笔': 6, '解决方案': 1, '学习笔记': 20, '转载': 1},
  articles: {'java': 0, 'python': 3, 'c': 0, 'vue': 17, 'css': 0, 'jquery': 0, 'js': 1, 'mysql': 0, 'sqlite': 0, 'mongodb': 0, '数据库': 0, '前端': 18, '后端': 4, '前沿技术': 0, '深度学习': 0, '大数据': 0, '数据分析': 0, '职业': 0, '诗词歌赋': 2, '个人规划': 3, '心情日志': 1, '黑客': 1}
}
export default data